import { UserRole, UserRoleEnum } from '@/models/features/user.models'

export const IGLOO_LOGS_ROLES: readonly UserRole[] = [
  UserRoleEnum.enum.Administrator,
  UserRoleEnum.enum.Manager,
  UserRoleEnum.enum.PropertyManager,
]

export const IGLOO_LOGS_DEFAULT_MONTHS = 6

export const IGLOO_LOGS_MAX_YEARS = 2

export const IGLOO_LOGS_FILE_PAGE = 'Igloo Logs'

export const IGLOO_LOGS_START_DATE_ID = 'igloo-logs-start-date'

export const IGLOO_LOGS_END_DATE_ID = 'igloo-logs-end-date'
